export const proOnline = {
  id: "pro-online",
  code: "06",
  brand: "ProOnline",
  nameJa: "オンライン事務代行",
  nameEn: "Online Back-Office",
  accent: "secondary",
  icon: "ri-computer-line",
  taglineJa: "必要な時間だけ。オンライン専業の秘書チーム。",
  taglineEn: "An online-only assistant team, billed by the hour you need.",
  leadJa:
    "UbiProの前身事業であり、グループ内のオンライン事務代行として続いています。経理・スケジュール調整・資料作成・顧客対応まで、必要な時間だけスポットで依頼できます。採用よりも早く、教育コストをかけずに戦力になります。",
  leadEn:
    "The origin business of UbiPro. Accounting, scheduling, document preparation and customer support — delivered by an online-only team, on demand.",
  heroImage:
    "/images/proonline.jpg",
  stats: [
    { value: "320", unit: "社", labelJa: "利用企業数", labelEn: "Companies served" },
    { value: "48", unit: "時間", labelJa: "月間 平均削減時間", labelEn: "Monthly hours saved" },
    { value: "94", unit: "%", labelJa: "継続率", labelEn: "Retention rate" },
    { value: "40", unit: "名", labelJa: "在籍秘書", labelEn: "Assistants on team" },
  ],
  challenges: [
    {
      icon: "ri-user-unfollow-line",
      titleJa: "採用しても事務が回らない",
      titleEn: "Hiring isn't enough",
      descJa: "募集をかけても採れない、採れても育つまで時間がかかり、結局は既存メンバーに負荷が戻っていませんか。",
    },
    {
      icon: "ri-calendar-event-line",
      titleJa: "繁忙期だけ人手がほしい",
      titleEn: "Peak-season spikes",
      descJa: "決算月やキャンペーン期間だけ業務が集中し、その時期だけ人を増やせると助かるケースが多くあります。",
    },
    {
      icon: "ri-scales-3-line",
      titleJa: "秘書を雇うほどでもない",
      titleEn: "Too small to hire",
      descJa: "月に数十時間の事務のために正社員を採用するのは重い。そんな規模感のご相談が最も多いです。",
    },
  ],
  strengths: [
    {
      icon: "ri-timer-line",
      titleJa: "1時間から依頼できる",
      titleEn: "From one hour",
      descJa: "月額の最低契約時間を設けつつ、スポット利用は1時間単位から。小さく始められます。",
    },
    {
      icon: "ri-rocket-line",
      titleJa: "最短3営業日で稼働",
      titleEn: "Live in 3 days",
      descJa: "業務整理が済めば最短3営業日で担当が稼働。採用・研修の期間が不要です。",
    },
    {
      icon: "ri-shield-check-line",
      titleJa: "専任担当制",
      titleEn: "Dedicated assistant",
      descJa: "担当が毎回変わることはありません。社内の空気感を理解した同じ担当が継続して対応します。",
    },
    {
      icon: "ri-file-list-2-line",
      titleJa: "引き継ぎまで設計",
      titleEn: "Built to hand over",
      descJa: "手順書を整備しながら進めるため、将来社内で内製化する際もスムーズに移行できます。",
    },
  ],
  menu: [
    {
      icon: "ri-calendar-check-line",
      titleJa: "スケジュール調整",
      titleEn: "Scheduling",
      descJa: "商談の日程調整、会議室の手配、カレンダー管理を代行します。",
    },
    {
      icon: "ri-receipt-line",
      titleJa: "経理・請求書業務",
      titleEn: "Accounting support",
      descJa: "請求書の発行、入金確認、経費精算のとりまとめ、記帳補助まで対応します。",
    },
    {
      icon: "ri-slideshow-line",
      titleJa: "資料・スライド作成",
      titleEn: "Documents & decks",
      descJa: "提案資料、社内共有資料、マニュアルの体裁を整えて納品します。",
    },
    {
      icon: "ri-customer-service-line",
      titleJa: "顧客対応",
      titleEn: "Customer support",
      descJa: "メール・チャットの一次対応、FAQ整備、問い合わせの切り分けを行います。",
    },
    {
      icon: "ri-search-eye-line",
      titleJa: "リサーチ・情報整理",
      titleEn: "Research",
      descJa: "競合調査、候補先リストの作成、社内ナレッジの整理を担当します。",
    },
  ],
  pricing: [
    {
      nameJa: "スポット利用",
      nameEn: "Spot",
      price: "1時間 4,400円",
      priceNote: "税別 / 1時間",
      descJa: "まずは少量から試したい方へ。",
      features: ["1時間単位で依頼", "業務内容の指定可", "初回ヒアリング込み", "追加は都度見積"],
      recommended: false,
    },
    {
      nameJa: "月20時間プラン",
      nameEn: "20h / month",
      price: "月額 77,000円",
      priceNote: "税別",
      descJa: "日常の事務を安定して任せたい方へ。",
      features: ["月20時間の専用枠", "専任担当制", "業務手順書の整備", "月次の稼働レポート"],
      recommended: true,
    },
    {
      nameJa: "月40時間プラン",
      nameEn: "40h / month",
      price: "月額 143,000円",
      priceNote: "税別",
      descJa: "事務全般をまとめて任せたい方へ。",
      features: ["月40時間の専用枠", "複数業務の並行対応", "定例ミーティング", "繁忙期の追加枠相談可"],
      recommended: false,
    },
  ],
  priceNoteJa: "表示金額はすべて税別の目安です。業務内容・稼働時間により個別にお見積りします。",
  flow: [
    { step: "01", titleJa: "ご相談", titleEn: "Consultation", descJa: "任せたい業務と、月あたりの想定時間を伺います。" },
    { step: "02", titleJa: "業務整理", titleEn: "Scoping", descJa: "業務を分解し、引き継ぎ範囲と手順を整理します。" },
    { step: "03", titleJa: "担当決定", titleEn: "Matching", descJa: "業務内容に合った専任担当をアサインします。" },
    { step: "04", titleJa: "稼働開始", titleEn: "Start", descJa: "最短3営業日で稼働。週次で状況を共有します。" },
  ],
  faq: [
    { q: "機密情報を扱ってもらえますか？", a: "秘密保持契約を締結したうえで対応します。アクセス権限を限定した環境で業務を行います。" },
    { q: "使っているツールを変える必要はありますか？", a: "いいえ。すでにお使いのチャット・カレンダー・会計ソフトに合わせて運用します。" },
    { q: "担当者を変更できますか？", a: "可能です。業務内容との相性を確認しながら、必要であれば担当の変更をご提案します。" },
    { q: "最低契約期間はありますか？", a: "月額プランは3ヶ月を目安としていますが、スポット利用であれば契約期間の縛りはありません。" },
  ],
  related: ["prosku", "pro-estate"],
};